import React, { useEffect, useState } from 'react';
import '../../../Styles/ageRange.css'
import ReactSlider from 'react-slider';
import { getAllReligion, getCast, getCountry, getMaritualStatus, getMotherTongue } from '../../../asiosConfig';
import { toast } from 'react-toastify';
import { Autocomplete, Slider, styled, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function ageValueText(value) {
    return `${value} years`;
}

function heightValueText(value) {
    return `${value} cm`;
}
const CustomSlider = styled(Slider)({
    color: '#FF8008',
    height: 4,
    '& .MuiSlider-thumb': {
        backgroundColor: '#FF8008',
        border: '2px solid #FF8008',
        '&:hover': {
            boxShadow: '0 0 0 8px rgba(255, 128, 8, 0.16)',
        },
    },
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-rail': {
        opacity: 0.5,
    },
});
const minDistance = 3;
export const Filter = ({ onSubmit }) => {
    const [ageRange, setAgeRange] = useState([18, 100]);
    const [heightRange, setHeightRange] = useState([150, 200]);
    const [country, setCountry] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedReligion, setSelectedReligion] = useState(null);
    const [religionList, setReligionList] = useState([]);
    const [community, setCommunity] = useState('');
    const [motherTongue, setMotherTongue] = useState('');
    const [maritalStatus, setMaritalStatus] = useState('');
    const [selectedCommunity, setSelectedCommunity] = useState(null);
    const [selectedMaritalStatus, setSelectedMaritalStatus] = useState(null);
    const [selectedMotherTongue, setSelectedMotherTongue] = useState(null);
    const navigate = useNavigate();
    // const indiaId = 233;

    // Handle age slider change
    const handleAgeChange = (event, value, activeThumb) => {
        if (!Array.isArray(value)) {
            return;
        }

        if (activeThumb === 0) {
            setAgeRange([Math.min(value[0], ageRange[1] - minDistance), ageRange[1]]);
        } else {
            setAgeRange([ageRange[0], Math.max(value[1], ageRange[0] + minDistance)]);
        }
    };

    // Handle height slider change
    const handleHeightChange = (event, values, activeThumb) => {
        if (!Array.isArray(values)) {
            return;
        }
        if (values[1] - values[0] < minDistance) {
            if (activeThumb === 0) {
                const clamped = Math.min(values[0], 250 - minDistance); // Assuming max height is 250 cm
                setHeightRange([clamped, clamped + minDistance]);
            } else {
                const clamped = Math.max(values[1], minDistance);
                setHeightRange([clamped - minDistance, clamped]);
            }
        } else {
            setHeightRange(values);
        }
    };
    const handleSubmit = () => {
        const filters = {
            ageRange,
            heightRange,
            country: selectedCountry ? selectedCountry.value : '',
            religion: selectedReligion ? selectedReligion.value : '',
            community: selectedCommunity ? selectedCommunity.value : '',
            motherTongue: selectedMotherTongue ? selectedMotherTongue.value : '',
            maritalStatus: selectedMaritalStatus ? selectedMaritalStatus.value : '',
        };
        if (Object.keys(filters).length === 0) {
            return;
        }

        const matchesType = 'my_matches';
        navigate(`/${matchesType}`, { state: { filters: filters } });

    }
    useEffect(() => {
        const accordionHeaders = document.querySelectorAll('.accordion-header');

        const fetchCountry = async () => {
            try {
                const response = await getCountry();
                if (response.status === 200 || response.status === 201) {
                    // setCountry(response.data.data);
                    const formattedCountry = response.data.data.map((country) => ({
                        value: country.id,
                        label: country.country,
                    }));
                    setCountry(formattedCountry);
                } else {
                    toast.error("Error in fetching Country");
                }
            } catch (error) {
                toast.error(error);
            }
        }

        const fetchReligion = async () => {
            try {
                const response = await getAllReligion();
                if (response.status === 200 || response.status === 201) {
                    // setReligionList(response.data.data);
                    const formattedReligion = response.data.map((religion) => ({
                        value: religion.id,
                        label: religion.religion,
                    }))
                    setReligionList(formattedReligion);
                } else {
                    toast.error("Error in fetching Religion");
                }
            } catch (error) {
                toast.error(error);
            }
        }

        const fetchMaritalStatus = async () => {
            try {
                const response = await getMaritualStatus();
                if (response.status === 200 || response.status === 201) {
                    const formattedMaritalStatus = response.data.map((item) => ({
                        value: item.id,
                        label: item.status,
                    }));
                    setMaritalStatus(formattedMaritalStatus);
                } else {
                    toast.error("Error in fetching Marital Status");
                }
            } catch (error) {
                toast.error(error);
            }
        }

        const fetchMotherTongue = async () => {
            try {
                const response = await getMotherTongue();
                if (response.status === 200 || response.status === 201) {
                    const formattedMotherTongue = response.data.data.map((item) => ({
                        value: item.id,
                        label: item.domain,
                    }));
                    setMotherTongue(formattedMotherTongue);
                } else {

                }
            } catch (error) {

            }
        }
        // Handle accordion click event
        const handleAccordionClick = (event) => {
            const button = event.currentTarget;
            const accordionContent = button.nextElementSibling;

            button.classList.toggle('active');

            if (button.classList.contains('active')) {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
            } else {
                accordionContent.style.maxHeight = 0;
            }

            // Close other open accordion items
            accordionHeaders.forEach((otherButton) => {
                if (otherButton !== button) {
                    otherButton.classList.remove('active');
                    otherButton.nextElementSibling.style.maxHeight = 0;
                }
            });
        };

        accordionHeaders.forEach(button => {
            button.addEventListener('click', handleAccordionClick);
        });
        fetchCountry();
        fetchReligion();
        fetchMaritalStatus();
        fetchMotherTongue();
        // Cleanup event listeners on component unmount
        return () => {
            accordionHeaders.forEach(button => {
                button.removeEventListener('click', handleAccordionClick);
            });
        };
    }, []);

    const fetchCast = async (religion_id) => {
        try {
            const response = await getCast(religion_id);
            if (response.status === 200 || response.status === 201) {
                const formattedCommunity = response.data.data.map((community) => ({
                    value: community.id,
                    label: community.caste,
                }));

                setCommunity(formattedCommunity);
            } else {
                toast.error("Error in fetching cast");
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const handleReligionChange = (event, value) => {
        setSelectedReligion(value);
        if (value) {
            fetchCast(value.value);
        } else {
            setCommunity([]);
            setSelectedCommunity(null);
        }
    };
    const [value, setValue] = useState(30);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="col-lg-9 col-12">
            <div>
                <div className="filterTitle">
                    <h3>Refine Matches</h3>
                </div>
                <div className="accordion-container mt-4">
                    <div className="accordion-item">
                        <button className="accordion-header">Age <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <h5 className="rangeTitle">Select a minimum age range of 3 years to get relevant matches</h5>
                            {/* <p className="ageRange">Selected Age range</p> */}
                            <Typography gutterBottom>Age Range</Typography>
                            <CustomSlider
                                value={ageRange}
                                onChange={handleAgeChange}
                                valueLabelDisplay='auto'
                                getAriaValueText={ageValueText}
                                min={1}
                                max={100}
                                step={1}
                                disableSwap
                            />
                        </div>
                    </div>

                    <div className="accordion-item">
                        <button className="accordion-header">Height <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <h5 className="rangeTitle">Select a minimum height range of 6 inches to get relevant matches</h5>
                            <Typography gutterBottom>Height Range(In cm)</Typography>
                            <CustomSlider
                                value={heightRange}
                                onChange={handleHeightChange}
                                valueLabelDisplay='auto'
                                getAriaValueText={heightValueText}
                                disableSwap
                                min={100} // Assuming minimum height is 100 cm
                                max={250} // Assuming maximum height is 250 cm
                                step={1} />
                        </div>
                    </div>

                    <div className="accordion-item">
                        <button className="accordion-header">Country <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <div className="mt-3">
                                <Autocomplete
                                    options={country}
                                    getOptionLabel={(option) => option.label}
                                    key={(option) => option.value}
                                    value={selectedCountry}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(event, newValue) => setSelectedCountry(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Select Country" variant="outlined" />}
                                />
                            </div>
                            <br />
                        </div>
                    </div>

                    <div className="accordion-item">
                        <button className="accordion-header">Religion <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <div className="mt-3">
                                <Autocomplete
                                    options={religionList}
                                    getOptionLabel={(option) => option.label}
                                    key={(option) => option.value}
                                    value={selectedReligion}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(event, newValue) => {
                                        setSelectedReligion(newValue);
                                        handleReligionChange(event, newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Select Religion" variant="outlined" />}
                                />
                            </div>
                            <br />
                        </div>
                    </div>

                    <div className="accordion-item">
                        <button className="accordion-header">Community <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <div className="mt-3">
                                <Autocomplete
                                    options={community}
                                    getOptionLabel={(option) => option.label}
                                    key={(option) => option.value}
                                    value={selectedCommunity}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(event, newValue) => setSelectedCommunity(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Select Community" variant="outlined" />}
                                    disabled={!selectedReligion}
                                />
                            </div>
                            <br />
                        </div>
                    </div>

                    <div className="accordion-item">
                        <button className="accordion-header">Mother Tongue <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <div className="mt-3">
                                <Autocomplete
                                    options={motherTongue}
                                    getOptionLabel={(option) => option.label}
                                    key={(option) => option.value}
                                    value={selectedMotherTongue}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(event, newValue) => setSelectedMotherTongue(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Select Mother Tongue" variant="outlined" />}
                                />
                            </div>
                            <br />
                        </div>
                    </div>

                    <div className="accordion-item">
                        <button className="accordion-header">Marital Status <span className="icon">+</span></button>
                        <div className="accordion-content">
                            <div className="mt-3">
                                <Autocomplete
                                    options={maritalStatus}
                                    getOptionLabel={(option) => option.label}
                                    key={(option) => option.value}
                                    value={selectedMaritalStatus}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(event, newValue) => setSelectedMaritalStatus(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Select Marital Status" variant="outlined" />}
                                />
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
                <div className="mt-5 text-center">
                    <button className="btn cancleBtn">Cancel</button> &nbsp;
                    <button className="btn subBtn" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    );
};
